module.exports = __webpack_public_path__ + "media/images/pc/stores/common/instagram/photographer_sns_05-cf3b07252009df1ec9c8fd0577b837cb.jpg";